import Piano from '../piano/piano.js';
import DebugHelper from '../helpers/debug-helper';
import GEA from './gea';

class GeaMetering {
	constructor() {
		this.userState = { granted: false };
		this.logger = new DebugHelper('GEA Metering');

		// Bind methods to the current instance so 'this' can be used
		// when methods are called inside external
		this.publisherEntitlementPromise =
			this.publisherEntitlementPromise.bind(this);
		this.handleLoginPromise = this.handleLoginPromise.bind(this);
		this.handleShowPaywall = this.handleShowPaywall.bind(this);
		this.handleUnlockArticle = this.handleUnlockArticle.bind(this);
		this.init = this.init.bind(this);
	}

	publisherEntitlementPromise() {
		const self = this;
		return new Promise((resolve) => {
			self.logger.log('Entitlement promise running', null);
			Piano.geaGetUserState()
				.then((userStateFromPiano) => {
					self.logger.log('Piano user state found:', userStateFromPiano);
					resolve(userStateFromPiano);
				})
				.catch((error) => {
					console.error('Entitlement promise failed: ', error);
				});
		});
	}

	handleLoginPromise() {
		const self = this;
		return new Promise(() => {
			// eslint-disable-next-line no-undef
			GaaMetering.getLoginPromise().then(() => {
				self.logger.log('Handle login');
				Piano.geaHandleLogin(window.location.href);
			});
		});
	}

	handleShowPaywall() {
		this.logger.log('Handle show paywall');
		Piano.geaShowPaywall();
	}

	handleUnlockArticle() {
		this.logger.log('Handle unlock article');
		Piano.geaUnlockArticle();
	}

	init(swgUrl) {
		this.logger.log('Init metering');

		if (typeof swgUrl === 'undefined') {
			console.error('No swgUrl found');
		}

		if (typeof window.bi_gea.allowed_referrers === 'undefined') {
			console.error('No allowed referrers found');
		}

		const args = {
			authorizationUrl: swgUrl,
			userState: this.userState,
			allowedReferrers: window.bi_gea.allowed_referrers,
			handleLoginPromise: this.handleLoginPromise(),
			publisherEntitlementPromise: this.publisherEntitlementPromise(),
			unlockArticle: this.handleUnlockArticle,
			showPaywall: this.handleShowPaywall,
			shouldInitializeSwG: false,
		};

		this.logger.log('Init metering with args:', args);

		// Push some extra actions to the SWG queue
		self.SWG.push((subscriptions) => {
			// Reset the SWG state (this is required for GEA to work)
			this.logger.log('Reset SWG:', subscriptions);
			subscriptions.reset();

			// Initialize the listening for GEA events
			GEA.listenForEvents(subscriptions);
		});

		// eslint-disable-next-line no-undef
		GaaMetering.init(args);
	}
}

const instance = new GeaMetering();
export default instance;
